import React, { Fragment, useEffect, useState } from "react";
import Humberg from "../../../elements/Humberg.jsx";

import { useDispatch, useSelector } from "react-redux";
import { allPmmsAction, clearErrors } from "../../../redux/actions/userActions.js";
import SinglePMM from "./singlePmm.jsx";
import LoaderBlock from "../../loader/LoaderBlock.jsx";
import { toast } from "react-toastify";
import { UPDATE_USER_STATUS_RESET } from "../../../redux/constants/userConstant.js";
import { useSearchParams } from "react-router-dom";

const Admins = () => {



    const dispatch = useDispatch()

    const { loading, PMMs, totalPMM, totalPages, blockedUsers, tempBlockedUsers } = useSelector((state) => state.getPMMs)
    const { user } = useSelector((state) => state.verifyEmailStore)

    const { error, message } = useSelector(state => state.inviteUser)


    const [searchParams] = useSearchParams();

    const admin_id = searchParams.get("admin_id");


    const [keyword, setKeyword] = useState('');
    const [status, setStatus] = useState('');
    const [perPage, setPerPage] = useState('20');
    const [page, setPage] = useState('1');
    const [referBy, setReferBy] = useState('');
    const [adminId, setAdminId] = useState('');



    useEffect(() => {
        const Headerlinkks = document.querySelectorAll(".headerLinks");
        const subLinks = document.querySelectorAll(".subLinks");
        const element = document.getElementById("dashboard")
        const subElement = document.getElementById("pmm-list");


        Headerlinkks.forEach(el => el.classList.remove("activeHeaderLink"));
        subLinks.forEach(el => el.classList.remove("activeSubLink"));
        element?.classList.add("activeHeaderLink");
        subElement?.classList.add("activeSubLink");

        document.title = `PMM List - Admin Panel`;

    }, []);
    // Remove one quantity






    useEffect(() => {

        let query = {}
        if (keyword) query.keyword = keyword
        if (status) query.status = status
        if (perPage) query.perPage = perPage
        if (referBy) query.referBy = referBy
        if (adminId) query.admin_id = adminId
        query.page = page
        query.role = "PMM"


        dispatch(allPmmsAction(query))

    }, [keyword, status, perPage, referBy, adminId, page, dispatch])



    useEffect(() => {


        if (error) {
            toast.error(error)
            dispatch(clearErrors())
        }

        if (message) {
            dispatch({ type: UPDATE_USER_STATUS_RESET })
            dispatch(allPmmsAction())
        }


    }, [error, message, dispatch])




    useEffect(() => {

        if (admin_id) {
            setAdminId(admin_id)
        }

    }, [admin_id])



    return (
        <Fragment>
            <Humberg header="Dashboard" headerLink="/" children={"Pending Approval"} />
            <section className="p-[1.5vmax] mt-[1vmax]" >
                <div className="flex justify-center gap-[1.5vmax] mb-[2vmax] flex-wrap">
                    {/* PMMs Stat Card */}
                    <div className="flex-1 min-w-[200px] bg-white p-[1.5vmax] rounded-xl border border-gray-100 shadow-sm flex justify-between items-center">
                        <div>
                            <span className="text-[2vmax] font-bold text-gray-800 block">{totalPMM || 0}</span>
                            <span className="text-gray-500 font-medium text-[0.9vmax] uppercase tracking-wider">PMMs</span>
                        </div>
                        <div className="w-[3vmax] h-[3vmax] bg-green-50 text-green-600 rounded-full flex items-center justify-center">
                            <i className="fa-solid fa-check text-[1.5vmax]"></i>
                        </div>
                    </div>

                    {/* Permanent Blocked Stat Card */}
                    <div className="flex-1 min-w-[200px] bg-white p-[1.5vmax] rounded-xl border border-gray-100 shadow-sm flex justify-between items-center">
                        <div>
                            <span className="text-[2vmax] font-bold text-gray-800 block">{blockedUsers || 0}</span>
                            <span className="text-gray-500 font-medium text-[0.9vmax] uppercase tracking-wider">Permanent Blocked</span>
                        </div>
                        <div className="w-[3vmax] h-[3vmax] bg-red-50 text-red-600 rounded-full flex items-center justify-center">
                            <i className="fa-solid fa-xmark text-[1.5vmax]"></i>
                        </div>
                    </div>

                    {/* Temporary Blocked Stat Card */}
                    <div className="flex-1 min-w-[200px] bg-white p-[1.5vmax] rounded-xl border border-gray-100 shadow-sm flex justify-between items-center">
                        <div>
                            <span className="text-[2vmax] font-bold text-gray-800 block">{tempBlockedUsers || 0}</span>
                            <span className="text-gray-500 font-medium text-[0.9vmax] uppercase tracking-wider">Temporary Blocked</span>
                        </div>
                        <div className="w-[3vmax] h-[3vmax] bg-orange-50 text-orange-600 rounded-full flex items-center justify-center">
                            <i className="fa-regular fa-hourglass-half text-[1.3vmax]"></i>
                        </div>
                    </div>
                </div>

                <div className="bg-white p-[2vmax] rounded-xl border border-gray-100 shadow-sm">
                    <div className="flex justify-between gap-[1.5vmax] items-center mb-[2vmax] flex-wrap">
                        {/* Search Bars */}
                        <div className="flex gap-[1vmax] flex-wrap flex-1">
                            <div className="w-full lg:w-[200px] flex items-center bg-gray-50 border border-gray-100 p-[0.7vmax_1vmax] rounded-lg focus-within:border-indigo-300 transition-colors">
                                <span className="text-gray-400 mr-[0.5vmax]" >
                                    <i className="fa-solid fa-magnifying-glass"></i>
                                </span >
                                <input 
                                    type="text" 
                                    className="w-full bg-transparent outline-none text-[0.9vmax] font-medium text-gray-700 placeholder-gray-400" 
                                    placeholder="Search PMM..."
                                    value={keyword}
                                    onChange={(e) => {
                                        setKeyword(e.target.value)
                                        setPage(1)
                                    }}
                                />
                            </div>
                            <div className="w-full lg:w-[200px] flex items-center bg-gray-50 border border-gray-100 p-[0.7vmax_1vmax] rounded-lg focus-within:border-indigo-300 transition-colors">
                                <span className="text-gray-400 mr-[0.5vmax]" >
                                    <i className="fa-solid fa-magnifying-glass"></i>
                                </span>
                                <input 
                                    type="text" 
                                    className="w-full bg-transparent outline-none text-[0.9vmax] font-medium text-gray-700 placeholder-gray-400" 
                                    placeholder="Refered By Id..."
                                    value={referBy}
                                    onChange={(e) => {
                                        setReferBy(e.target.value)
                                        setPage(1)
                                    }}
                                />
                            </div>
                            {user?.role !== "ADMIN" &&
                                <div className="w-full lg:w-[200px] flex items-center bg-gray-50 border border-gray-100 p-[0.7vmax_1vmax] rounded-lg focus-within:border-indigo-300 transition-colors">
                                    <span className="text-gray-400 mr-[0.5vmax]" >
                                        <i className="fa-solid fa-magnifying-glass"></i>
                                    </span>
                                    <input 
                                        type="text" 
                                        className="w-full bg-transparent outline-none text-[0.9vmax] font-medium text-gray-700 placeholder-gray-400" 
                                        placeholder="Admin ID..."
                                        value={adminId}
                                        onChange={(e) => {
                                            setAdminId(e.target.value)
                                            setPage(1)
                                        }}
                                    />
                                </div>
                            }
                        </div>

                        {/* Filters */}
                        <div className="flex items-center gap-[1vmax] flex-wrap">
                            <span className="text-gray-500 font-medium text-[0.9vmax]">Filter by:</span>
                            
                            {/* Status Filter */}
                            <div className="relative bg-gray-50 border border-gray-100 rounded-lg focus-within:border-indigo-300 transition-colors">
                                <select 
                                    className="pl-[1vmax] pr-[2vmax] py-[0.7vmax] text-[0.9vmax] font-medium text-gray-700 outline-none bg-transparent appearance-none"
                                    value={status}
                                    onChange={(e) => {
                                        setStatus(e.target.value)
                                        setPage(1)
                                    }}
                                >
                                    <option value="">Status</option>
                                    <option value="ACTIVE">Active</option>
                                    <option value="BLOCKED">Blocked</option>
                                    <option value="TEMPORARILY_BLOCKED">Temporary Block</option>
                                </select>
                                <span className="absolute right-[0.7vmax] top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none">
                                    <i className="fa-solid fa-chevron-down text-xs"></i>
                                </span>
                            </div>

                            {/* Per Page */}
                            <div className="relative bg-gray-50 border border-gray-100 rounded-lg focus-within:border-indigo-300 transition-colors">
                                <select 
                                    className="pl-[1vmax] pr-[2vmax] py-[0.7vmax] text-[0.9vmax] font-medium text-gray-700 outline-none bg-transparent appearance-none"
                                    value={perPage}
                                    onChange={(e) => {
                                        setPerPage(e.target.value)
                                        setPage(1)
                                    }}
                                >
                                    <option value="1">1</option>
                                    <option value="5">5</option>
                                    <option value="10">10</option>
                                    <option value="20">20</option>
                                </select>
                                <span className="absolute right-[0.7vmax] top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none">
                                    <i className="fa-solid fa-chevron-down text-xs"></i>
                                </span>
                            </div>
                        </div>
                    </div>

                    <div className="w-full overflow-x-auto">
                        <div className="flex bg-zinc-50 border border-zinc-100 py-[0.8vmax] rounded-xl min-w-[1400px] mb-[1.5vmax] shadow-sm">
                            <div className="text-center flex-[0.4] text-zinc-600 font-jakarta font-semibold uppercase text-[0.8vmax] tracking-wider" >
                                No.
                            </div>
                            <div className="px-[1vmax] flex-[1.2] text-zinc-600 font-jakarta font-semibold uppercase text-[0.8vmax] tracking-wider" >
                                Name
                            </div>
                            <div className="px-[1vmax] flex-[2.2] text-zinc-600 font-jakarta font-semibold uppercase text-[0.8vmax] tracking-wider" >
                                Email
                            </div>
                            <div className="text-center px-[0.5vmax] flex-[0.6] text-zinc-600 font-jakarta font-semibold uppercase text-[0.8vmax] tracking-wider" >
                                Products
                            </div>
                            <div className="text-center px-[0.5vmax] flex-[0.6] text-zinc-600 font-jakarta font-semibold uppercase text-[0.8vmax] tracking-wider" >
                                PMM ID
                            </div>
                            <div className="text-center px-[0.5vmax] flex-[0.8] text-zinc-600 font-jakarta font-semibold uppercase text-[0.8vmax] tracking-wider" >
                                User ID
                            </div>
                            <div className="text-center px-[0.5vmax] flex-[1.2] text-zinc-600 font-jakarta font-semibold uppercase text-[0.8vmax] tracking-wider" >
                                Refered By
                            </div>
                            <div className="text-center px-[0.5vmax] flex-[1] text-zinc-600 font-jakarta font-semibold uppercase text-[0.8vmax] tracking-wider" >
                                JOINED
                            </div>
                            <div className="text-center px-[0.5vmax] flex-[1.2] text-zinc-600 font-jakarta font-semibold uppercase text-[0.8vmax] tracking-wider" >
                                Status
                            </div>
                            <div className="text-center px-[0.5vmax] flex-[2.3] text-zinc-600 font-jakarta font-semibold uppercase text-[0.8vmax] tracking-wider" >
                                Actions
                            </div>
                        </div>
                        {loading ?
                            <LoaderBlock />
                            :
                            PMMs?.length > 0 ?
                                PMMs.map((pmm, index) =>
                                    <SinglePMM key={pmm.id} PMM={pmm} index={index} totalPMMs={PMMs?.length} user={user}
                                    />)
                                :
                                <div className="text-center text-[1.5vmax] text-gray-400 py-[3vmax]" >
                                    No data found
                                </div>

                        }
                    </div>
                </div>

            </section>
            {totalPages > 1 && (
                <div className="flex gap-[1vmax] justify-center mt-[2vmax]">

                    {/* Prev button */}
                    <button
                        className="pagination-btn"
                        disabled={page === 1}
                        onClick={() => setPage(page - 1)}
                    >
                        Prev
                    </button>

                    {/* --- SMART PAGINATION START --- */}
                    {(() => {
                        const pages = [];
                        const maxVisible = 3; // number of pages to show around current page

                        const addPage = (p) => {
                            pages.push(
                                <button
                                    key={p}
                                    className={`pagination-btn ${page === p ? "active" : ""}`}
                                    onClick={() => setPage(p)}
                                >
                                    {p}
                                </button>
                            );
                        };

                        // Always show First Page
                        addPage(1);

                        // Left dots
                        if (page > maxVisible + 2) {
                            pages.push(<span key="dots-left">...</span>);
                        }

                        // Middle pages (dynamic)
                        for (
                            let p = Math.max(2, page - maxVisible);
                            p <= Math.min(totalPages - 1, page + maxVisible);
                            p++
                        ) {
                            addPage(p);
                        }

                        // Right dots
                        if (page < totalPages - (maxVisible + 1)) {
                            pages.push(<span key="dots-right">...</span>);
                        }

                        // Always show Last Page
                        if (totalPages > 1) {
                            addPage(totalPages);
                        }

                        return pages;
                    })()}
                    {/* --- SMART PAGINATION END --- */}

                    {/* Next button */}
                    <button
                        className="pagination-btn"
                        disabled={page === totalPages}
                        onClick={() => setPage(page + 1)}
                    >
                        Next
                    </button>

                </div>
            )}

        </Fragment>
    );
};

export default Admins;
